import { useQuerySnackbar } from '@explorer/hooks';
import { ControlUserContactInfoResponse } from '@explorer/open-api-client';
import { ContactInfo } from '@explorer/open-api-client/models/ContactInfo';
import { useV1APIMutation } from '@explorer/query';
import { useQueryClient } from '@tanstack/react-query';

export const useMutationUpdateEscalationClientContacts = (params: {
  client_id: string;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}) => {
  const { client_id } = params;
  const { snackError, snackSuccess } = useQuerySnackbar();
  const queryClient = useQueryClient();

  return useV1APIMutation<ControlUserContactInfoResponse, ContactInfo>({
    mutationKey: ['v1ControlWebAdminClientClientIdContactsPatch', client_id],
    mutationFn(contactInfo: ContactInfo, client) {
      return client.v1ControlWebAdminClientClientIdContactsPatch({
        client_id,
        ControlUserContactInfoAddUpdateRequest: contactInfo,
      });
    },
    onSuccess: (data) => {
      snackSuccess('Contact information updated successfully');

      queryClient.invalidateQueries([
        'v1ControlWebAdminClientClientIdContactsGet',
        client_id,
      ]);

      if (params.onSuccess) {
        params.onSuccess();
      }
    },
    explorerAPIOptions: {
      clientId: client_id,
      onError: (error) => {
        snackError('Failed to update contact information', error.error);

        if (params.onError) {
          params.onError(error);
        }
      },
    },
  });
};
